<template>
  <div>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <v-text-field class="input-text-size"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.adjType" label="Adj Type" />
      </v-col>
      <v-col cols="12" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.description"
         label="Description" />
      </v-col>
      <v-col cols="12" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size"
        v-uppercase=globalSettingItem.conEverythingToCaps
        v-model="editedItem.assessorCodes"
         label="Assessor Codes" />
      </v-col>
      <v-col cols="12" class="pt-0 pb-0 mt-n3">
        <v-checkbox class="input-text-size radio-and-checekbox-size" v-model="editedItem.supplement"
          label="Supplement" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'taxAdjTypesDialog',
  mixins: [GlobalToCaps],

  props: {
    baseCrudKey: {
      type: String,
      default: 'taxAdjTypesList',
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
    ]),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
  },
};
</script>
